"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrCatalogsOrderedCard = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_select_input_1 = require("@hotelplan/components.common.select-input");
const fdr_lib_misc_catalogs_1 = require("@hotelplan/fdr.lib.misc.catalogs");
const fdr_catalogs_ordered_card_styles_1 = require("./fdr-catalogs-ordered-card.styles");
const useCatalogItemVariantsSelect_1 = require("./useCatalogItemVariantsSelect");
const FdrCatalogsOrderedCard = ({ item, onRemove, onSwap, cardConfig, }) => {
    const { image, title, from, to, type, id, variants } = item;
    const [t, i18n] = (0, next_i18next_1.useTranslation)(['catalogs', 'common', 'forms']);
    const language = i18n.language;
    const { showTitle, showVariants } = cardConfig;
    const selectProps = (0, useCatalogItemVariantsSelect_1.useCatalogItemVariantsSelect)(item);
    const onSelectChange = (nextId) => {
        if (!variants)
            return;
        const prevVariant = variants.find(variant => variant.id === id);
        const nextVariant = variants.find(variant => variant.id === nextId);
        if (!prevVariant || !nextVariant)
            return;
        onSwap(prevVariant, nextVariant);
    };
    return (react_1.default.createElement(fdr_catalogs_ordered_card_styles_1.CatalogCardInfoFormWrap, { "data-id": `${type}_${id}` },
        react_1.default.createElement("div", { className: "imageWrap" },
            react_1.default.createElement(fdr_catalogs_ordered_card_styles_1.CatalogCardInfoImage, { image: image })),
        react_1.default.createElement(fdr_catalogs_ordered_card_styles_1.CatalogCardInfoFormContent, null,
            react_1.default.createElement("div", { className: "wrapper" },
                showTitle && react_1.default.createElement("h3", { className: "heading" }, title),
                variants && showVariants ? (react_1.default.createElement(components_common_select_input_1.SelectInput, Object.assign({}, selectProps, { onChange: onSelectChange }))) : (react_1.default.createElement("div", { className: "validity-dates" },
                    react_1.default.createElement("strong", null, t('catalogs:validity.title')),
                    react_1.default.createElement("p", { className: "catalogDates" }, `${(0, fdr_lib_misc_catalogs_1.formatToCatalogsDate)(from, language)} ${t('catalogs:to')} ${(0, fdr_lib_misc_catalogs_1.formatToCatalogsDate)(to, language)}`)))),
            react_1.default.createElement(fdr_catalogs_ordered_card_styles_1.DeleteButtonWrap, null,
                react_1.default.createElement(fdr_catalogs_ordered_card_styles_1.DeleteCatalogButton, { onClick: onRemove }, t('forms:delete.button'))))));
};
exports.FdrCatalogsOrderedCard = FdrCatalogsOrderedCard;
//# sourceMappingURL=fdr-catalogs-ordered-card.js.map